import { render, staticRenderFns } from "./OrderComplaintUntreated.vue?vue&type=template&id=0a9421f2&"
import script from "./OrderComplaintUntreated.vue?vue&type=script&lang=ts&"
export * from "./OrderComplaintUntreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports